import {
  extractServiceProviderGroupMembershipFromTokenPayload,
  getTokenPayloadFromToken,
} from '@pflegenavi/shared/utils';

export const getGlobalServiceProviderIdFromToken = (
  token: string | undefined
): string | undefined => {
  const serviceProviderGroups =
    extractServiceProviderGroupMembershipFromTokenPayload(
      getTokenPayloadFromToken(token)
    );

  if (serviceProviderGroups && serviceProviderGroups.length > 0) {
    return serviceProviderGroups[0];
  }
  return undefined;
};
